import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { PaymentPlanEnum } from 'src/configs/APISchemas/BindPolicy';
import { PaymentFormValues } from 'src/pages/payment-msi/PaymentMsiV2/PaymentMsiV2';
import { DisclosuresButton } from 'src/pages/payment-msi/PaymentMsiV2/components/DisclosuresButton';
import { TermsAndConditionsButton } from 'src/pages/payment-msi/PaymentMsiV2/components/TermsAndConditionsButton';
import { PaymentPlanOption } from 'src/pages/payment-msi/PaymentMsiV2/utils';
import { getPurchasePolicyInput } from 'src/redux/selectors/purchasePolicy';
import { AppTheme } from 'src/themes/muiTheme';
import { PaymentSection } from './PaymentSection';

const legalSectionStyles = {
  root: (theme: AppTheme) => {
    const tabletMaxSize = theme.breakpoints.values.lg + 1;
    const tablet = theme.breakpoints.down(tabletMaxSize);

    return {
      marginTop: '40px',
      marginBottom: '32px',
      display: 'flex',
      alignItems: 'center',
      columnGap: '8px',
      [tablet]: {
        alignItems: 'flex-start',
      },
    };
  },
};

interface LegalSectionProps {
  paymentPlanOptions: PaymentPlanOption[];
}

export function LegalSection({ paymentPlanOptions }: LegalSectionProps) {
  const purchasePolicyInput = useSelector(getPurchasePolicyInput);

  const { control, watch } = useFormContext<PaymentFormValues>();

  const currentPaymentPlan = watch('paymentPlan');
  const renterEmail = purchasePolicyInput.email;
  const buildingState = purchasePolicyInput.buildingAddress?.value?.state ?? '';
  const monthlyPaymentData = paymentPlanOptions.find(
    (option) => option.value === PaymentPlanEnum.Monthly,
  );
  const annualPaymentData = paymentPlanOptions.find(
    (option) => option.value === PaymentPlanEnum.Annual,
  );
  const monthlyInstallment = monthlyPaymentData
    ? `${monthlyPaymentData.price}`
    : '';
  const monthlyDownPaymentAmount = monthlyPaymentData
    ? `${monthlyPaymentData.duePayment}`
    : '';
  const annualAmountPremium = annualPaymentData
    ? `${annualPaymentData.price}`
    : '';

  return (
    <PaymentSection sx={legalSectionStyles.root}>
      <Controller
        control={control}
        name="agreed"
        render={({ field }) => {
          return (
            <Checkbox
              value={field.value}
              onChange={(_event, checked) => field.onChange(checked)}
            />
          );
        }}
      />
      <Typography component={'div'}>
        I have read, understand and agree to the Automatic Payment{' '}
        <TermsAndConditionsButton>
          Terms and Conditions
        </TermsAndConditionsButton>
        , and{' '}
        <DisclosuresButton
          annualAmountPremium={annualAmountPremium}
          email={renterEmail}
          paymentType={currentPaymentPlan}
          monthlyInstallment={monthlyInstallment}
          monthlyDownPaymentAmount={monthlyDownPaymentAmount}
          buildingState={buildingState}
        >
          Disclosures
        </DisclosuresButton>{' '}
        and intend this checkbox to serve as my electronic signature accepting
        such terms and conditions.
      </Typography>
    </PaymentSection>
  );
}
